import { getTruthyValue } from "@draftkings/sportsbook-common-utils";
import { mapArrayElement } from "../../../helpers";
export function mapEvents(eventsMap) {
    const mappedEvents = {};
    for (const [eventId, eventArray] of Object.entries(eventsMap)) {
        mappedEvents[eventId] = mapEvent(eventArray);
    }
    return mappedEvents;
}
function mapParticipants(participantsArray) {
    return participantsArray ? participantsArray.map(participant => ({
        id: participant[0],
        name: participant[1],
        venueRole: participant[2],
        country: participant[3],
        metadata: participant[4],
        isNationalTeam: participant[5],
        countryCode: participant[6],
    })) : participantsArray;
}
function mapScore(scoreArray) {
    return {
        homeScore: scoreArray[0],
        awayScore: scoreArray[1],
        name: scoreArray[2],
    };
}
export function mapEventScore(eventScoreArray) {
    var _a;
    return {
        mainScore: Array.isArray(eventScoreArray[0]) ? mapScore(eventScoreArray[0]) : {},
        gamePartScores: Array.isArray(eventScoreArray[1]) ? eventScoreArray[1].map(mapScore) : [],
        extraPartScores: Array.isArray(eventScoreArray[2]) ? eventScoreArray[2].map(mapScore) : undefined,
        currentGamePartScore: (_a = mapArrayElement(eventScoreArray[3], mapScore)) !== null && _a !== void 0 ? _a : undefined,
        statScores: Array.isArray(eventScoreArray[4]) ? eventScoreArray[4].map(mapScore) : undefined,
        isSettlementScore: eventScoreArray[5],
        metadata: eventScoreArray[6],
    };
}
function mapEvent(eventArray) {
    var _a;
    return {
        sportId: eventArray[0],
        eventId: eventArray[1],
        eventStartDate: eventArray[2],
        eventType: eventArray[3],
        eventDisplayName: eventArray[4],
        isTeamSwap: eventArray[5],
        homeTeamName: eventArray[6],
        awayTeamName: eventArray[7],
        isLive: eventArray[8],
        status: eventArray[9],
        liveGameState: mapArrayElement(eventArray[11], mapLiveGameState),
        tags: eventArray[12],
        participants: mapParticipants(eventArray[13]),
        media: eventArray[14],
        leagueId: eventArray[15],
        eventScore: (_a = mapArrayElement(eventArray[16], mapEventScore)) !== null && _a !== void 0 ? _a : undefined,
    };
}
export function mapLiveGameState(liveGameStateArray) {
    return {
        clockRunning: liveGameStateArray[0],
        clockDirection: liveGameStateArray[1],
        gameTime: liveGameStateArray[2],
        gamePart: getTruthyValue(liveGameStateArray[3], undefined)
    };
}
//# sourceMappingURL=mapEvent.js.map